import { getPlatformConfig } from './supabase';

/**
 * Storefront link helpers.
 *
 * Production: https://<slug>.<domain>. Local dev: the storefront Worker on
 * :8788 (`http://<slug>.localtest.me:8788`) — the same host resolution and SEO
 * shell as production, without needing TLS or a portless domain. These helpers
 * exist so the dashboard never hardcodes "adop.app" and silently links people
 * (or previews) at production while developing.
 */

function isLocalDevHost(): boolean {
  if (typeof window === 'undefined') return false;
  const { hostname } = window.location;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.localtest.me')
  );
}

/** Scheme + host of a location's storefront, no trailing slash. */
export function storefrontOriginFor(slug: string): string {
  const { storefront_base_domain: domain } = getPlatformConfig();
  return isLocalDevHost() ? `http://${slug}.${domain}:8788` : `https://${slug}.${domain}`;
}

export function storefrontUrlFor(slug: string, path = '/'): string {
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${storefrontOriginFor(slug)}${suffix}`;
}

/**
 * The preview-link API returns an absolute URL built server-side; rebuild it
 * against the origin this browser can actually reach and keep its token.
 */
export function previewUrlFor(slug: string, apiUrl: string): string {
  const token = new URL(apiUrl, window.location.origin).searchParams.get('preview');
  if (!token) throw new Error('The preview link response did not include a preview token.');
  return `${storefrontOriginFor(slug)}/?preview=${encodeURIComponent(token)}`;
}
